import { ChargeDataEnquiryRepoImpl } from "domain/repository/ChargeDataEnquiry/ChargeDataEnquiryRepoImpl";
import { ChargeDetailRepoImpl } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepoImpl";
import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { SearchPreferenceRepoImpl } from "domain/repository/Common/SearchPreferenceRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { SpecialHandlingIndMappingRepoImpl } from "domain/repository/SpecialHanldingInd/SpecialHandlingIndMappingRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { useChargeDataSearchTracked } from "presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider";
import { ChargeDataSearchVM } from "presentation/viewModel/ChargeDataEnquiry/ChargeDataEnquiryVM/ChargeDataSearchVM";
import { useMemo } from "react";

export const useChargeDataSearchVM = () => {
    const [, setChargeDataSearchState] = useChargeDataSearchTracked();
    const chargeDataSearchVM = useMemo(() =>
        ChargeDataSearchVM({
            dispatch: [setChargeDataSearchState],
            companyRepo: CompanyRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            specialhandlingIndMappingRepo: SpecialHandlingIndMappingRepoImpl(),
            chargeDataEnquiryRepo: ChargeDataEnquiryRepoImpl(),
            searchPreferenceRepo: SearchPreferenceRepoImpl(),
            chargeDetailRepo: ChargeDetailRepoImpl(),
        }), [setChargeDataSearchState])

    return chargeDataSearchVM
}